export class GrpcMetaValue<T> {
  constructor(
    public readonly key: GrpcMeta<T>,
    public readonly value: T,
  ) {}

  public is<K>(key: GrpcMeta<K>): this is GrpcMetaValue<K> {
    return Object.is(this.key, key);
  }
}

export class GrpcMeta<T> {
  public provide(value: T): GrpcMetaValue<T> {
    return new GrpcMetaValue<T>(this, value);
  }
}

export class GrpcContext {
  public static EMPTY = new GrpcContext(null, []);

  private readonly parent: GrpcContext | null;
  private readonly values: GrpcMetaValue<unknown>[];

  private constructor(
    parent: GrpcContext | null,
    values: GrpcMetaValue<unknown>[],
  ) {
    this.parent = parent ?? null;
    this.values = values;
  }

  public *getValues<T>(key: GrpcMeta<T>): IterableIterator<T> {
    for (const metaValue of this.values) {
      if (metaValue.is(key)) {
        yield metaValue.value;
      }
    }

    if (this.parent !== null) {
      yield* this.parent.getValues(key);
    }
  }

  public nest(values: GrpcMetaValue<unknown>[]): GrpcContext {
    return new GrpcContext(this, values);
  }
}
